import { Breadcrumb } from 'peach/components'
import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import LoanAutopay from './Autopay/LoanAutopay'
import LoanLedger from './Ledger/Ledger'
import LoanAdvances from './LoanAdvances/LoanAdvances'
import LoanBalances from './LoanBalances'
import LoanBasics from './LoanBasics'
import LoanDocuments from './LoanDocuments/LoanDocuments'
import DrawsRoutes from './LoanDraws/DrawsRoutes'
import LoanExpectedPayments from './LoanExpectedPayments'
import LoanFees from './LoanFees'
import LoanObligations from './LoanObligations'
import LoanPeriods from './LoanPeriods'
import LoanRates from './LoanRates'
import LoanRefunds from './LoanRefunds'
import LoanStatements from './LoanStatements/LoanStatements'
import LoanTransaction from './LoanTransaction'
import LoanTransactions from './LoanTransactions'
import LoanTimeline from './Timeline/LoanTimeline'

// import { usePersonId } from 'peach/scopes/person'
// import { useLoanId } from 'peach/scopes/loan'

const LoanRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <LoanBasics />
      </Route>

      <Route crumb path={`${path}/timeline`}>
        <LoanTimeline />
      </Route>

      <Route crumb path={`${path}/rates`}>
        <LoanRates />
      </Route>

      <Route crumb exact path={`${path}/transactions`}>
        <LoanTransactions />
      </Route>

      <Route path={`${path}/transactions/:transactionId`}>
        <Breadcrumb title='Transactions' to={`${url}/transactions`} />

        <LoanTransaction />
      </Route>

      <Route crumb path={`${path}/expected-payments`}>
        <LoanExpectedPayments />
      </Route>

      <Route crumb path={`${path}/obligations`}>
        <LoanObligations />
      </Route>

      <Route crumb path={`${path}/autopay`}>
        <LoanAutopay />
      </Route>

      <Route crumb path={`${path}/balances`}>
        <LoanBalances />
      </Route>

      <Route crumb path={`${path}/draws`}>
        <DrawsRoutes />
      </Route>

      <Route crumb path={`${path}/refunds`}>
        <LoanRefunds />
      </Route>

      <Route crumb path={`${path}/fees`}>
        <LoanFees />
      </Route>

      <Route crumb path={`${path}/documents`}>
        <LoanDocuments />
      </Route>

      <Route crumb path={`${path}/statements`}>
        <LoanStatements />
      </Route>

      <Route crumb path={`${path}/periods`}>
        <LoanPeriods />
      </Route>

      <Route crumb path={`${path}/ledger`}>
        <LoanLedger />
      </Route>

      <Route crumb path={`${path}/advances`}>
        <LoanAdvances />
      </Route>

      <Redirect to={`${url}`} />
    </Switch>
  )
}

export default LoanRoutes
